<div class="modal-header">
    <h4 class="modal-title fw-bold" id="sampleSearchListHeader" jhiTranslate="bmsjHipsterApp.sample.list.search.title">Search for lists of Samples</h4>
    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-hidden="true"
            (click)="reset()">
    </button>
</div>
<div class="modal-body">
    <div class="row">
        <div class="col-8 mb-3 d-flex align-items-center">
            <div jhiTranslate="bmsjHipsterApp.sample.list.search.results">Click results to work with.<br/></div>
        </div>
    </div>
    <div class="row">
        <div class="col-md-12">
            <div class="searchbar">
                <form #searchListForm="ngForm">
                    <div class="col-md-6">
                        <div class="float-component">
                            <input type="text" class="form-control" [(ngModel)]="searchString" (keydown.enter)="searchList()" name="searchString"
                                   id="searchString" maxlength="100"/>
                        </div>
                        <div class="float-component">
                            <button type="button" class="btn btn-info" (click)="searchList()" jhiTranslate="search">Search
                            </button>
                        </div>
                        <div class="float-component" (click)="displayHelpPopup = true;">
                            <div class="popup-help-button"> ?</div>
                        </div>
                    </div>
                    <div class="col-md-4 pt-2">
                        <div class="float-component">
                            <input type="checkbox" class="form-check-input" [(ngModel)]="exactMatch" name="exactMatch" checked=""/>
                        </div>
                        <div class="float-component" jhiTranslate="bmsjHipsterApp.sample.list.search.exact.matches">
                            Exact matches only
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
    <br/>
    <span>{{ 'bmsjHipsterApp.sample.list.search.total.results' | translate }}<b>{{sampleListResults.length}}</b></span>
    <!--<div class="row">
        <div class="col-md-12">-->
    <div class="row pt-3">
        <div class="col-12">
            <div class="table-responsive custom-scroll-style" style="max-height: 400px;">
                <table class="table table-striped table-bordered table-curved">
                    <thead class="sticky-header">
                    <tr jhiSort [(predicate)]="predicate" [(ascending)]="reverse" [callback]="searchList.bind(this)">
                        <th jhiSortBy="listName"><span jhiTranslate="bmsjHipsterApp.sample.list.name">NAME</span> <span class="fa fa-sort"></span></th>
                        <th jhiSortBy="description"><span jhiTranslate="bmsjHipsterApp.sample.list.desc">DESCRIPTION</span> <span class="fa fa-sort"></span></th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr *ngFor="let sampleList of sampleListResults; trackBy: trackId;" (click)="selectList(sampleList)"
                        [class.selected]="sampleList.id == selectedListId">
                        <td>{{sampleList.listName}}</td>
                        <td>{{sampleList.description}}</td>
                    </tr>
                    <tr *ngIf="!sampleListResults || sampleListResults.length === 0">
                        <td colspan="2">{{'no.data' | translate}}</td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
    <div class="popup" *ngIf="displayHelpPopup" (mouseleave)="hideHelpPopup()" (click)="hideHelpPopup()">
        <div class="popupContent">
            <div class="v-label" aria-hidden="false" id="descLbl" style="width: 300px;"
				[innerHTML]="'bmsjHipsterApp.sample.list.search.message' | translate">
            </div>
        </div>
    </div>
</div>

